import { Typography } from '@doveit/lego';
import React from 'react';

const PrivacyPolicyFooter = () => (
  <Typography.SMALLER color="neutrals.medium">
    Compilando il form autorizzi il trattamento dei dati per le finalità del servizio, come definito nella
    {' '}
    <a href="/privacy-policy" target="_blank">Privacy policy</a>
    .
  </Typography.SMALLER>
);

export default PrivacyPolicyFooter;
